import React, { useState, useContext } from 'react';
import { authContext } from '../context';

const TestLogin = () => {
  const { login, isLoggedin, userData, loading } = useContext(authContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [testResult, setTestResult] = useState('');

  const handleTestLogin = async (e) => {
    e.preventDefault();
    setTestResult('Testing login...');
    
    try {
      const result = await login(email, password);
      
      if (result.success) {
        setTestResult('✅ Login successful!');
      } else {
        setTestResult(`❌ Login failed: ${result.error}`);
      }
    } catch (error) {
      setTestResult(`❌ Error: ${error.message}`);
    }
  };

  const handleTestAuth = () => {
    setTestResult(`🔍 Auth Status: ${isLoggedin ? 'Logged In' : 'Not Logged In'}`);
    if (userData) {
      setTestResult(prev => prev + ` | User: ${userData.name || userData.email}`);
    }
  };

  return (
    <div style={{ 
      padding: '20px', 
      border: '2px solid #ccc', 
      borderRadius: '8px', 
      margin: '20px',
      backgroundColor: '#f9f9f9'
    }}>
      <h3>🔐 Login Functionality Test</h3>
      
      <div style={{ marginBottom: '20px' }}>
        <h4>Current Status:</h4>
        <p><strong>Loading:</strong> {loading ? 'Yes' : 'No'}</p>
        <p><strong>Is Logged In:</strong> {isLoggedin ? 'Yes' : 'No'}</p>
        <p><strong>User Data:</strong> {userData ? JSON.stringify(userData, null, 2) : 'None'}</p>
      </div>

      <form onSubmit={handleTestLogin} style={{ marginBottom: '20px' }}>
        <div style={{ marginBottom: '10px' }}>
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="test@example.com"
            style={{ 
              width: '100%', 
              padding: '8px', 
              marginTop: '5px',
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}
            required
          />
        </div>
        
        <div style={{ marginBottom: '10px' }}>
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="password"
            style={{ 
              width: '100%', 
              padding: '8px', 
              marginTop: '5px',
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}
            required
          />
        </div>
        
        <button 
          type="submit" 
          disabled={loading}
          style={{
            backgroundColor: '#007bff',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer',
            marginRight: '10px'
          }}
        >
          {loading ? 'Testing...' : 'Test Login'}
        </button>
      </form>

      <button 
        onClick={handleTestAuth}
        style={{
          backgroundColor: '#28a745',
          color: 'white',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          marginRight: '10px'
        }}
      >
        Check Auth Status
      </button>

      {testResult && (
        <div style={{ 
          marginTop: '20px', 
          padding: '10px', 
          backgroundColor: '#e9ecef', 
          borderRadius: '4px',
          fontFamily: 'monospace'
        }}>
          <strong>Test Result:</strong><br />
          {testResult}
        </div>
      )}

      <div style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        <h4>💡 Test Tips:</h4>
        <ul>
          <li>Frontend runs on <code>http://localhost:3001</code></li>
          <li>Backend should run on <code>http://localhost:3000</code></li>
          <li><strong>API Endpoints:</strong></li>
          <li>• Login: <code>POST /api/auth/login</code></li>
          <li>• Logout: <code>POST /api/auth/logout</code></li>
          <li>• User Details: <code>GET /api/auth/user-details</code></li>
          <li>Check browser console for any errors</li>
          <li>Check Network tab in DevTools to see API calls</li>
        </ul>
      </div>
    </div>
  );
};

export default TestLogin;
